import React, {useContext} from 'react'
import Web from '../../../assets/web.jpg'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { appContext } from '../../../Context/appProvider';
import { baseUrl } from '../../../constants';
import { Link } from 'react-router-dom';
import { settingsContext } from '../../../Context/settingsProvider';

export default function L4() {
    const {token, categories} = useContext(appContext)
    const {t} = useContext(settingsContext)
  return (
    <div className='flex flex-col gap-5 p-5'>
        <p className='text-black text-xl font-bold tracking-wide'>{t('EXPLORE_CATEGORIES')}</p>
        <div className='grid grid-cols-3 max-md:grid-cols-1 gap-x-1 gap-y-1'>
            {
                categories?.map(category => (
                    <Link to={'/category/' + category.name.replace(/ /g, '-')} className='hover:bg-top transition-all duration-500 ease-in-out border-white border-[1px] border-solid w-full h-[230px] relative bg-cover bg-center rounded-md flex items-center justify-center overflow-hidden' style={{
                        backgroundImage: 'url(' + baseUrl + category.cover + ')'
                    }}>
                        <div className='absolute inset-0 bg-[#00000085] flex items-center justify-center p-2'>
                            <h1 className='text-white text-[30px] font-bold text-center'>{category.name}</h1>
                            {/* <ArrowForwardIosIcon style={{fontSize: 22, marginLeft: 7, color: 'white'}}>Filled</ArrowForwardIosIcon> */}
                        </div>
                    </Link>
                ))
            }
            

        </div>
    </div>
  )
}